import React, { useRef, useState } from "react"
import styles from './Login.module.scss'
import { useAuth } from '../contexts/AuthContext';
import eventBus from "../utils/EventBus";
import ConfirmEmail from "./ConfirmEmail";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import useRegistrationStatus from '../Hooks/useRegistrationStatus';

export default function Register() {
    const usernameRef = useRef();
    const emailRef = useRef();
    const passwordRef = useRef();
    const confirmPasswordRef = useRef();
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { register } = useAuth();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirm, setShowConfirm] = useState(false);
    const registrationEnabled = useRegistrationStatus();

    async function handleSubmit(e) {
        e.preventDefault();
        setError('');

        if (passwordRef.current.value !== confirmPasswordRef.current.value) {
            return setError('Passwords do not match');
        }

        setLoading(true);

        try {
            const result = await register(
                usernameRef.current.value,
                emailRef.current.value,
                passwordRef.current.value
            );
            
            if (!result.success) {
                setError(result.error);
            } else {
                const email = emailRef.current.value;
                eventBus.publish('modal', {
                    title: "Confirm your email",
                    content: <ConfirmEmail email={email} justSent/>
                })
            }
        } catch (err) {
            setError('Failed to create an account');
        } finally {
            setLoading(false);
        }
    }

    if (!registrationEnabled) {
        return (
            <div className={styles.login}>
                <div className={styles.form}>
                    <h3 className={styles.title}>Register</h3>
                    <div className={styles.error}>Registration is currently disabled.</div>
                </div>
            </div>
        );
    }

    return (
        <div className={styles.login}>
            <form className={styles.form} onSubmit={handleSubmit}>
                <div>
                    <h3 className={styles.title}>Register</h3>
                    {error && <div className={styles.error}>{error}</div>}
                    <label>Username</label>
                    <input ref={usernameRef} type="text" placeholder="Enter Username" required/>
                    <label>Email</label>
                    <input ref={emailRef} type="email" placeholder="Enter Email" required/>
                    <label>Password</label>
                    <div className={styles.passwordField}>
                        <input ref={passwordRef} type={showPassword ? 'text' : 'password'} placeholder="Enter Password" required/>
                        <button type="button" className={styles.toggleButton} onClick={() => setShowPassword(!showPassword)} aria-label={showPassword ? 'Hide password' : 'Show password'}>
                            <FontAwesomeIcon icon={showPassword ? faEye : faEyeSlash} />
                        </button>
                    </div>
                    <label>Confirm Password</label>
                    <div className={styles.passwordField}>
                        <input ref={confirmPasswordRef} type={showConfirm ? 'text' : 'password'} placeholder="Confirm Password" required/>
                        <button type="button" className={styles.toggleButton} onClick={() => setShowConfirm(!showConfirm)} aria-label={showConfirm ? 'Hide password' : 'Show password'}>
                            <FontAwesomeIcon icon={showConfirm ? faEye : faEyeSlash} />
                        </button>
                    </div>
                    <button type="submit" disabled={loading}>
                        {loading ? 'Creating account...' : 'Register'}
                    </button>
                </div>
            </form>
        </div>
    )
} 